import { TagListItem } from '@/models/dictionary/tag-list.model';

export const tagListToTagIdList = (tagList: TagListItem[]): string[] => {
  return tagList.map(({ tagId }: TagListItem) => tagId);
};
